import Vue from 'vue';
export var vm = new Vue();


// WEBPACK FOOTER //
// ./src/common/js/vm.js